module.exports = __webpack_public_path__ + "static/media/create.56c663b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/create.svg
// module id = 251
// module chunks = 0